export default "__VITE_ASSET__CTEZcWGj__"